import { useState, useCallback } from 'react';

/**
 * Hook para manejar las notificaciones de validación de asientos
 */
export const useSeatValidation = () => {
  const [validationError, setValidationError] = useState(null);
  const [recommendations, setRecommendations] = useState([]);

  // Mostrar error de validación
  const showValidationError = useCallback((message) => {
    setValidationError(message);
    // Limpiar el error después de 5 segundos
    setTimeout(() => {
      setValidationError(null);
    }, 5000);
  }, []);

  // Limpiar error de validación
  const clearValidationError = useCallback(() => {
    setValidationError(null);
  }, []);

  // Mostrar recomendaciones
  const showRecommendations = useCallback((recs) => {
    setRecommendations(recs);
    // Limpiar las recomendaciones después de 10 segundos
    setTimeout(() => {
      setRecommendations([]);
    }, 10000);
  }, []);

  // Limpiar recomendaciones
  const clearRecommendations = useCallback(() => {
    setRecommendations([]);
  }, []);

  // Función para manejar la selección de asiento recomendado
  const selectRecommendedSeat = useCallback((seatId, onSeatClick) => {
    if (onSeatClick) {
      onSeatClick(seatId);
    }
    clearRecommendations();
  }, [clearRecommendations]);

  return {
    validationError,
    recommendations,
    showValidationError,
    clearValidationError,
    showRecommendations,
    clearRecommendations,
    selectRecommendedSeat
  };
}; 